export default __webpack_public_path__ + "static/media/estatuto.0e17535c.pdf";